"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const round_1 = require("./helpers/round");
const formatWithPattern_1 = require("./helpers/formatWithPattern");
const getBasicFormat_1 = require("./helpers/getBasicFormat");
var SEPARATORS;
(function (SEPARATORS) {
    SEPARATORS["COMMA"] = ",";
    SEPARATORS["DOT"] = ".";
})(SEPARATORS = exports.SEPARATORS || (exports.SEPARATORS = {}));
class Formatter {
    constructor(oriCurrency) {
        this.oriCurrency = null;
        this.oriCurrency = oriCurrency;
    }
    formatCurrency(amount) {
        let { format } = this.oriCurrency;
        let groupSizes = this.oriCurrency.groupSize;
        let [groupSize] = groupSizes;
        let groupSeparator = this.oriCurrency[SEPARATORS.COMMA];
        let decimalSeparator = this.oriCurrency[SEPARATORS.DOT];
        let precision = this.oriCurrency.decimals;
        let { symbol } = this.oriCurrency;
        let negative = amount < 0;
        let pattern = this.oriCurrency.pattern[negative ? 0 : 1];
        let integer;
        let fraction;
        let value = "";
        // standard formatting like "c", don't have to parse custom format mask
        if (!format) {
            return getBasicFormat_1.default(amount, precision, {
                decimalSeparator,
                groupSize,
                groupSeparator,
                pattern,
                symbol
            });
        }
        let ZERO = "0";
        let SHARP = "#";
        let LITERAL_REGEXP = /(['][^']*[']?)|(["][^"]*["]?)|([^#0;,.])|(\\,)|(\\.)/g;
        let LITERAL_PLACEHOLDER = "?";
        let LITERAL_PLACEHOLDER_REGEXP = /\?/g;
        let literals = [];
        let hasGroups = false;
        let GROUP_REGEXP = /\,+(?!\,)/g;
        let formatSectionUsed = 0;
        const replaceLiterals = match => {
            let literal = match;
            if (literal.length > 2) {
                literal = literal.substr(1, literal.length - 2);
            }
            else if (literal.length > 1) {
                literal = literal.substr(1);
            }
            literals.push(literal);
            return LITERAL_PLACEHOLDER;
        };
        const replaceGroups = () => {
            hasGroups = true;
            return "";
        };
        const getProperFormatSection = (amount, format) => {
            formatSectionUsed = 0;
            let fmt = format.split(";");
            let result;
            if (amount < 0 && fmt[1]) {
                result = fmt[1];
                formatSectionUsed = 1;
            }
            else if (amount === 0) {
                if (fmt[2]) {
                    formatSectionUsed = 2;
                }
                result = fmt[2] || fmt[0];
            }
            else {
                result = fmt[0];
            }
            // remove obsolete literals from the literals array after format section split
            if (literals.length && fmt.length > 1) {
                let counts = [];
                let i;
                let l;
                for (i = 0, l = fmt.length; i < l; i++) {
                    counts.push((fmt[i].match(LITERAL_PLACEHOLDER_REGEXP) || []).length);
                }
                for (i = 0, l = formatSectionUsed; i < l; i++) {
                    literals.splice(0, counts[i]);
                }
                literals.splice(counts[formatSectionUsed], literals.length - counts[formatSectionUsed]);
            }
            return result;
        };
        format = format.replace(LITERAL_REGEXP, replaceLiterals);
        // split number according to decimal index when found
        integer = Math.abs(amount).toString().split(SEPARATORS.DOT);
        fraction = integer[1] ? integer[1] : "";
        // take proper format according to positive, zero or negative amount ( when specified )
        format = getProperFormatSection(amount, format);
        // find groups if any
        format = format.replace(GROUP_REGEXP, replaceGroups);
        const formatWithPlaceholders = format.replace(/\,/g, "");
        // get the raw number format without placeholders
        format = formatWithPlaceholders.replace(LITERAL_PLACEHOLDER_REGEXP, "");
        const literalsOnly = Boolean(!format.length && formatWithPlaceholders.length);
        // format the raw number ( integer & fraction part )
        let decimalIndex = format.indexOf(SEPARATORS.DOT);
        let zeroIndex = -1;
        let sharpIndex = -1;
        let hasZero = false;
        let hasSharp = false;
        if (decimalIndex > -1) {
            zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
            sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
            hasZero = zeroIndex > -1;
            hasSharp = sharpIndex > -1;
            precision = fraction.length;
            if (!hasZero && !hasSharp) {
                format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
                decimalIndex = -1;
                precision = 0;
            }
            if (hasZero && zeroIndex > sharpIndex) {
                precision = zeroIndex;
            }
            else if (sharpIndex > zeroIndex) {
                if (hasSharp && precision > sharpIndex) {
                    precision = sharpIndex;
                }
                else if (hasZero && precision < zeroIndex) {
                    precision = zeroIndex;
                }
            }
            amount = round_1.default(amount, precision > -1 ? precision : 0);
        }
        else {
            amount = round_1.default(amount);
        }
        // split rounded string value again
        integer = (literalsOnly ? "" : amount).replace("-", "").split(SEPARATORS.DOT);
        fraction = integer[1] ? integer[1] : "";
        integer = integer[0];
        hasGroups = Boolean(hasGroups && groupSeparator && groupSizes && groupSizes.length);
        // combine groups & literals addition in one loop ?
        let formatBeforeDot = formatWithPlaceholders.split(SEPARATORS.DOT);
        let formatAfterDot = formatBeforeDot[1] ? formatBeforeDot[1] : "";
        formatBeforeDot = formatBeforeDot[0];
        zeroIndex = formatBeforeDot.indexOf(ZERO);
        let i1 = formatBeforeDot.length - 1;
        let i2 = integer.length - 1;
        let c1;
        let c2;
        let getChars = function () {
            c1 = formatBeforeDot.charAt(i1);
            c2 = integer.charAt(i2);
        };
        let groupSizeIndex = -1;
        let groupCounter;
        let getGroupSize = function () {
            if (!hasGroups) {
                return;
            }
            groupCounter = 0;
            if (groupSizeIndex < groupSizes.length - 1) {
                groupSizeIndex++;
                groupSize = groupSizes[groupSizeIndex];
            }
        };
        let updateGroupCounter = function () {
            if (!hasGroups) {
                return;
            }
            if (groupCounter === groupSize) {
                value = groupSeparator + value;
                getGroupSize();
            }
            groupCounter++;
        };
        // format integer part - going from right to left here
        value = "";
        if (formatBeforeDot !== "") {
            getChars();
            getGroupSize();
            while (i1 > -1 || i2 > -1) {
                switch (c1) {
                    case LITERAL_PLACEHOLDER:
                        // literal placeholders are just copied to the resulting string in this step
                        value = LITERAL_PLACEHOLDER + value;
                        i1--;
                        break;
                    case ZERO:
                    case SHARP:
                        if ((i1 > zeroIndex || c1 === ZERO) && c2 === "") {
                            c2 = ZERO;
                        }
                        if (c2 !== "") {
                            // append group separator when prepending numeric chars and the amount
                            // of written numeric chars just went over current group size
                            updateGroupCounter();
                            // for zeros, always copy numeric char from the integer part or zero when not available
                            // for sharp copy numeric char only if available
                            value = c2 + value;
                        }
                        i1--;
                        if (i2 > -1) {
                            i2--;
                        }
                        break;
                    case "":
                        // copy remaining chars at start of integer part
                        if (c2 !== "") {
                            updateGroupCounter();
                            value = c2 + value;
                        }
                        if (i2 > -1) {
                            i2--;
                        }
                        break;
                }
                getChars();
            }
        }
        amount = value;
        // format decimals part
        if (formatAfterDot !== "") {
            zeroIndex = formatAfterDot.lastIndexOf(ZERO);
            let l1 = formatAfterDot.length;
            let l2 = fraction.length;
            i1 = 0;
            i2 = 0;
            getChars = function () {
                c1 = formatAfterDot.charAt(i1);
                c2 = fraction.charAt(i2);
            };
            value = "";
            getChars();
            getGroupSize();
            while (i1 < l1 || i2 < l2) {
                switch (c1) {
                    case LITERAL_PLACEHOLDER:
                        // literal placeholders are just copied to the resulting string in this step
                        value += LITERAL_PLACEHOLDER;
                        i1++;
                        break;
                    case ZERO:
                    case SHARP:
                        if ((i1 < zeroIndex || c1 === ZERO) && c2 === "") {
                            c2 = ZERO;
                        }
                        // for zeros, always copy numeric char from the integer part or zero when not available
                        // for sharp copy numeric char only if available
                        if (c2 !== "") {
                            value += c2;
                        }
                        i1++;
                        if (i2 < l2) {
                            i2++;
                        }
                        break;
                    case "":
                        // copy remaining chars at end of fraction part
                        if (c2 !== "") {
                            value += c2;
                        }
                        if (i2 < l2) {
                            i2++;
                        }
                        break;
                }
                getChars();
            }
            // append to amount; decimal separator should be used only when some
            // numeric chars were appended, means fraction string was set,
            // otherwise only literal(s) will be appended, if any
            amount += (fraction !== "" ? decimalSeparator : "") + value;
        }
        // replace the literals
        i1 = 0;
        amount = amount.replace(LITERAL_PLACEHOLDER_REGEXP, () => {
            let out = (literals.length > i1) ? literals[i1] : "";
            i1++;
            return out;
        });
        // trim the result
        amount = amount.trim();
        return formatWithPattern_1.default(pattern, amount, symbol);
    }
}
exports.default = Formatter;
